module.exports = __webpack_public_path__ + "img/product_adv.06cebbe2.jpg";